export const GET_GRAPH_URINE = "GET_GRAPH_URINE";
export const GET_GRAPH_URINE_PUBLIC = "GET_GRAPH_URINE_PUBLIC";
export const GET_GRAPH_URINE_SUCCESS = "GET_GRAPH_URINE_SUCCESS";
export const GET_GRAPH_URINE_FAILED = "GET_GRAPH_URINE_FAILED";
export const GET_GRAPH_URINE_RESET = "GET_GRAPH_URINE_RESET";

/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 */

export function actGetGraphUrine(payload, onSuccess, onError) {
    return {
        type: GET_GRAPH_URINE,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actGetGraphUrinePublic(payload, onSuccess, onError) {
    return {
        type: GET_GRAPH_URINE_PUBLIC,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actGetGraphUrineSuccess(payload) {
    return {
        type: GET_GRAPH_URINE_SUCCESS,
        payload: payload,
    }
}

export function actGetGraphUrineFailed() {
    return {
        type: GET_GRAPH_URINE_FAILED,
    }
}

export function actGetGraphUrineReset() {
    return {
        type: GET_GRAPH_URINE_RESET,
    }
}

export default {
    actGetGraphUrine,
    actGetGraphUrinePublic,
    actGetGraphUrineSuccess,
    actGetGraphUrineFailed,
    actGetGraphUrineReset
}